import React, { useState } from 'react'
import { Header } from '@st-operations/uikit/src/v2'

import TabSelector from '_components/tab-selector'
import Select from '_components/select'
import User from '_lib/User.js'

import OrganizationTab from './organization-tab'
import EnterpriseTab from './enterprise-tab'
import FreeUserTab from './free-user-tab'
import { ENV_OPTIONS, DEFAULT_ENV } from './helpers'

import './styles.scss'

const PredactivAdmin = () => {
  const [tab, setTab] = useState('Organization')
  const [env, setEnv] = useState(DEFAULT_ENV)

  const permissions = User?.data?.datasphere_permissions?.predactiv?.permissions || {}

  const SECTIONS = {}

  if (permissions.organization?.display) {
    SECTIONS.org = 'Organization'
  }

  if (permissions.free_trial_requests?.display) {
    SECTIONS.freeUserRequest = 'Free User Request'
  }

  if (permissions.enterprise_requests?.display) {
    SECTIONS.enterpriseUserRequest = 'Enterprise User Request'
  }

  return (
    <div className="predactiv-admin">
      <Header
        title={
          <div className="predactiv-admin__header">
            <span>Predactiv admin</span>
            <Select value={env} options={ENV_OPTIONS} onChange={(value) => setEnv(value)} />
          </div>
        }
      />
      <div>
        <TabSelector options={Object.values(SECTIONS)} onSelect={setTab} active={tab} />
      </div>
      <Choose>
        <When condition={tab === SECTIONS.org}>
          <OrganizationTab env={env.value} />
        </When>
        <When condition={tab === SECTIONS.enterpriseUserRequest}>
          <EnterpriseTab env={env.value} />
        </When>
        <When condition={tab === SECTIONS.freeUserRequest}>
          <FreeUserTab env={env.value} />
        </When>
        <When condition={tab === SECTIONS.activeUsers}>TODO</When>
        <Otherwise>Select a tab above</Otherwise>
      </Choose>
    </div>
  )
}

export default PredactivAdmin
